module.exports = __webpack_public_path__ + "static/media/publicsonar_crowdcontrol_default.a80443a7.svg";